import { withTheme } from 'styled-components'
import MainWrapper from './MainWrapper'

export default withTheme(MainWrapper)
